import { useReadAccess } from 'src/app/AppAuth/useReadAccess'
import React, { useCallback, useEffect, useMemo } from 'react'
import { MODEL_TYPE } from '@trustero/trustero-api-web/lib/common/model_pb'
import { CAPABILITY } from '@trustero/trustero-api-web/lib/authz/permissions_pb'
import { Changelog, useInfoPanelContext } from '../../../../InfoPanel'
import { ReactComponent as ChangelogIcon } from '../../../Icons/assets/changelog-icon.svg'
import { Tooltip } from '../../Tooltip'
import { IconButton, IconButtonVariant } from '../IconButton'

export const ChangelogButton = ({
  subjectModelIds,
  subjectIds,
  tooltipPlacement = 'top',
  subjectType,
  icon,
  onOpen,
}: {
  subjectModelIds?: string[]
  subjectIds?: string[]
  tooltipPlacement?: 'top' | 'bottom' | 'left' | 'right'
  subjectType?: MODEL_TYPE
  icon?: React.ReactNode
  onOpen?: () => void
}): JSX.Element => {
  const { setInfoPanelState } = useInfoPanelContext()
  const canViewActivities = useReadAccess(CAPABILITY.CAN_VIEW_ACTIVITY_LOG)

  const changeLog = useMemo(
    () => (
      <Changelog
        subjectmodelids={subjectModelIds}
        subjectIds={subjectIds}
        subjectType={subjectType}
        hideHeader={true}
      />
    ),
    [subjectModelIds, subjectIds, subjectType],
  )

  useEffect(() => {
    setInfoPanelState((prev) => ({
      ...prev,
      render: changeLog,
    }))
  }, [changeLog, setInfoPanelState])

  const onClick = useCallback(
    (e: React.MouseEvent<HTMLSpanElement | HTMLButtonElement>) => {
      onOpen?.()
      e.preventDefault()
      e.stopPropagation()
      setInfoPanelState((prev) => ({
        ...prev,
        isShown: true,
        render: changeLog,
        title: 'Activities',
      }))
    },
    [changeLog, setInfoPanelState, onOpen],
  )

  if (!canViewActivities) {
    return <></>
  }

  return (
    <Tooltip
      id={`changelog-tooltip-${subjectModelIds}`}
      placement={tooltipPlacement}
      tooltipBody="Activities"
    >
      {icon ? (
        <span onClick={onClick}>{icon}</span>
      ) : (
        <IconButton variant={IconButtonVariant.icon} onClick={onClick}>
          <ChangelogIcon width="24px" height="24px" />
        </IconButton>
      )}
    </Tooltip>
  )
}
